<template>

  <div class="main hidden-print">
    <!-- <div v-if="!isMobile && !close" class="action-bar">


      <span class="action-header-txt">
        <div tag="a" :to="{name: 'services-b2c'}" style="margin-top: -25px">
        <img src="../assets/img/svg/logo_zignet_branco 1.svg" class="img-header-vehicle">
      </div>
        Parcele multas, licenciamentos e IPVA em até 12X. &nbsp; &nbsp;
      </span>

      <div tag="button" @click="zapay_inicio" class="btn saiba-mais">
       CONSULTAR PLACA &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
       <div class="arrow-icon">
        <img src="../assets/img/svg/flecha-zignet.svg">
       </div>
           </div>
           <span class="close-alert" @click="fecharActionBar"
        ><img class="closeIcon" src="../assets/img/icons/close.svg"
      /></span>

    </div> -->

    <header :class="[isScrolling && 'scrolling', openMenuMobile && window.document.webview ? 'open-menu-webview' : openMenuMobile && 'open-menu']" >
      <div class="header-container">
        <router-link :to="{name: 'inicio'}">
          <div class="logo">
            <img :src="`../../static/${logo}`" :class="{ 'logo-pending-scroll-version': !isMobile && isScrolling }" style="pointer-events: none" alt="Logo Move Mais">
          </div>
        </router-link>

        <!-- <div @click="openMenuMobile = true" class="button-menu"> -->
        <div v-if="!openMenuMobile" @click="openMenuMobile = true" class="button-menu">
          <img class="mobile-icon" src="../../static/HotdogNewRoxo_375.svg" alt="HotdogNewRoxo_375"/>
        </div>

        <!-- <div @click="openMenuMobile = false" class="button-menu"> -->
        <div v-else @click="openMenuMobile = false" class="button-menu">
          <i style="font-size: 19px; margin-right: 20px" class="icon-cancel mobile-icon"></i>
        </div>

      </div>

      <template v-if="openMenuMobile || !isMobile">

        <div class="menu-container" @click="openMenuMobile = false">
            <router-link tag="div" class="item-menu" :to="{name: 'services'}">
                <i class="icon-coin2 mobile-icon"></i>
                <span>Planos</span>
            </router-link>

            <router-link  class="item-menu" tag="div" :to="{name: 'promo-toll-ticket'}">
                <i class="icon-toll-ticket mobile-icon"></i>
                <span>Vale-pedágio</span>
            </router-link>

            <router-link class="item-menu" tag="div" :to="{name: 'range'}">
                <i class="icon-pin mobile-icon"></i>
                <span>Cobertura</span>
            </router-link>

            <router-link class="item-menu" tag="div" :to="{name: 'move-mais'}">
                <i class="icon-move-plus mobile-icon"></i>
                <span>A Move Mais</span>
            </router-link>

            <!-- <router-link class="item-menu" tag="div" :to="{name: 'contact-partner'}">
              <img class="mobile-icon icon-img" src="../assets/img/shake_hands_new.svg" >
              <span>Parceiros</span>
            </router-link> -->

            <router-link class="item-menu" tag="div" :to="{name: 'withdrawall-points'}">
                <img class="mobile-icon icon-img" src="../../static/retirar_tag.svg" >
                <span>Retirar TAG</span>
            </router-link>

            <router-link class="item-menu" tag="div" :to="{name: 'contact'}">
                <i class="icon-mail mobile-icon"></i>
                <span>Contato</span>
            </router-link>

          <div class="item-menu">
            <span @click="open('https://blog.movemais.net/')">
              <img class="mobile-icon icon-img" src="../../static/blog.svg" >
              <span>blog+</span>
            </span>
          </div>

            <router-link class="item-menu account" tag="div" :to="{name: 'login'}">
                <i class="icon-avatar mobile-icon"></i>
                <span>Minha Conta</span>
            </router-link>
        </div>

        <div class="footer mobile">

          <span>Acompanhe-nos</span>

          <div class="media-container">
            <div class="media">
              <a href="https://www.facebook.com/MoveMais/" target="_blank">
                <i style="font-size: 15px" class="icon-facebook mobile"></i>
              </a>
            </div>

            <div class="media">
              <a href="https://www.instagram.com/movemais/" target="_blank">
                <i style="font-size: 15px" class="icon-instagram mobile"></i>
              </a>
            </div>

            <div class="media">
              <a href="https://www.linkedin.com/company/move-mais/" target="_blank">
                <i style="font-size: 15px" class="icon-linkedin mobile"></i>
              </a>
            </div>

            <div class="media">
              <a href="https://twitter.com/Move_Mais" target="_blank">
                <i style="font-size: 15px" class="icon-twitter mobile"></i>
              </a>
            </div>

            <div class="media">
              <a href="https://www.youtube.com/user/movemais" target="_blank">
                <i style="font-size: 15px" class="icon-youtube mobile"></i>
              </a>
            </div>
          </div>
        </div>
      </template>
    </header>
    <!-- <div v-if="!close && isMobile && !isLoginRoute" class="action-bar">

        <span class="action-header-txt" v-if="!isMobile">
          <div tag="a" :to="{name: 'services-b2c'}" style="margin-top: -25px">
          <img src="../assets/img/svg/logo_zignet_branco 1.svg" class="img-header-vehicle">
        </div>
          Parcele multas, lecenciamento e IPVA em até 12X. &nbsp; &nbsp;
        </span>

        <span class="action-header-txt" v-if="isMobile">
        <div tag="a" :to="{name: 'services-b2c'}" style="margin-top: -25px">
          <img src="../assets/img/svg/logo_zignet_branco 1.svg" class="img-header-vehicle">
        </div>
        Multas, licenciamento e IPVA em até 12X.
      </span>
        <div tag="button" @click="zapay_inicio" class="btn saiba-mais">
        CONSULTAR PLACA &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="arrow-icon">
          <img src="../assets/img/svg/flecha-zignet.svg">
        </div>
            </div>
            <span v-if="!isMobile" class="close-alert" @click="fecharActionBar"
          ><img class="closeIcon" src="../assets/img/icons/close.svg"
        /></span>

</div> -->
  </div>
</template>

<script>
import Sales from '../services/sales';
  export default {
    data() {
      return {
        isScrolling: false,
        openMenuMobile: false,
        isMobile: false,
        close: false,
        isLoginRoute: false
      }
    },

    created() {
      this.close = false;
      this.isMobile = window.innerWidth <= 769;
      this.isLoginRoute = this.$route.name === 'login';
    },

    watch: {
  '$route'() {
    this.isLoginRoute = this.$route.name === 'login';
  }
  },
    mounted() {
      // mudar a cor do background no desktop.
      window.addEventListener('scroll', () => window.scrollY > 0 ? this.isScrolling = true : this.isScrolling = false );

      // saber se está em desktop ou mobile.
      if(window.innerWidth <= 769) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }

      // evento disparado toda vez que a tela muda de tamanho
      window.addEventListener('resize', () => window.innerWidth <= 769 ? this.isMobile = true : this.isMobile = false );
    },
    computed: {
      home() {
          if (this.$router.name == 'inicio')
            return true;
        }
      ,
      logo() {
        if(this.isMobile) return 'Logo_Move_Mais_Horizontal_2026.svg';
        else if (this.isScrolling) return 'Logo_Move_Mais_Vertical_Branco_2026.svg';
        else return 'Logo_Move_Mais_Vertical_2026.svg';
      }
    },
    methods: {
      open(url) {
        window.open(url);
      },

      zapay_inicio(){
        Sales.gravaLogRedirecionamentoBanner(0, 1, 1).then(res => {
          console.log(res, "resposta")
        })

      const url = `https://www.zignet.com.br/parceiro/movemais-externo/`;
      window.open(url, '_blank');


    },

    fecharActionBar () {
      this.close = true;
    },

    }
  }
</script>

<style lang="scss" scoped>
  @import './app-header.scss';
</style>



// WEBPACK FOOTER //
// app-header.vue?52768f80